if (typeof debounce === 'undefined') {
  var debounce = function(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');

      // The drawer must live outside the header: .header-section creates a
      // stacking context (sticky, z-index 50) that sits below the
      // click-capture (52), so a fixed drawer left inside it could never
      // paint above the dim. It is rendered inside the header section for
      // access to the section's settings/blocks, then teleported to
      // #wrapper next to the other side panels. Stale copies from previous
      // section renders (theme editor) are removed first.
      const wrapper = document.getElementById('wrapper');
      if (this.menu && wrapper) {
        document.querySelectorAll('.mobile-menu-drawer').forEach((el) => {
          if (el !== this.menu) el.remove();
        });
        wrapper.appendChild(this.menu);
      }
      this._scrollTicking = false;
      this._stickyOffset = 0;

      // The drawer opens through OverlayManager, which provides the
      // click-capture, scroll lock, focus trap and Escape handling.
      // The hamburger state is synced from the panel events so every
      // close path (capture click, Escape, close button) resets it.
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        e.preventDefault();
        if (OverlayManager.isOpen(this.menu)) {
          OverlayManager.close(this.menu);
        } else {
          OverlayManager.open(this.menu);
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });
      document.addEventListener('panel:open', (e) => {
        if (e.detail.panel === this.menu) {
          this.toggle.classList.add('active');
        }
      });
      document.addEventListener('panel:closed', (e) => {
        if (e.detail.panel === this.menu) {
          this.toggle.classList.remove('active');
          this.toggle.removeAttribute('open');
        }
      });

      // Cache sticky offset and recalculate on resize
      this._cacheStickyOffset();
      window.addEventListener('resize', debounce(() => {
        this._cacheStickyOffset();
      }, 100));

      // Single scroll listener with rAF throttle
      window.addEventListener('scroll', () => {
        if (!this._scrollTicking) {
          this._scrollTicking = true;
          requestAnimationFrame(() => {
            this.setStickyClass();
            this.setHeaderOffset();
            this.setHeaderHeight();
            this._scrollTicking = false;
          });
        }
      }, { passive: true });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {
        window.addEventListener('scroll', () => this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    _cacheStickyOffset() {
      if (this.classList.contains('header-sticky--active')) {
        // Skip recalculation while sticky — the header is position:sticky at top:0,
        // so getBoundingClientRect().top would return 0 and corrupt the offset.
        if (this.classList.contains('is-sticky')) {
          return;
        }
        this._stickyOffset = parseInt(this.header_section.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
      }
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        this.classList.toggle('is-sticky', window.scrollY >= this._stickyOffset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      if (a_bar) {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      }
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentLinksEnabled = this.menu.dataset.parentLinks === 'true';

      // When parent links setting is on, only arrow opens submenu
      if (parentLinksEnabled) {
        event.preventDefault();
        const isArrowClick = event.target.closest('.link-forward');

        if (!isArrowClick) {
          const anchor = summaryElement.querySelector('a');
          if (anchor && anchor.href) {
            window.location.href = anchor.href;
          }
          return;
        }
        // Arrow clicked — manually open details
        detailsElement.setAttribute('open', '');
      }

      const parentMenuElement = detailsElement.closest('.link-container');

      // Stamp deferred template content on first open
      const tpl = detailsElement.querySelector(':scope > template.mobile-menu-deferred');
      if (tpl) {
        tpl.replaceWith(tpl.content.cloneNode(true));
        // Re-bind back buttons for the newly stamped content
        detailsElement.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
        detailsElement.querySelectorAll('details.link-container summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      }

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      // resize on initial load
      window.addEventListener('resize', debounce(() => {
        this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(() => {
        this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}

/**
   * geri sayim urun teslimi
   */
  
document.addEventListener('DOMContentLoaded', function() {
    // Geri sayım elementleri sayfada yoksa hiç çalışma (null hatası engellenir)
    const elHours = document.getElementById('hours');
    const elMinutes = document.getElementById('minutes');
    const elSeconds = document.getElementById('seconds');
    const elDelivery = document.getElementById('customDeliveryDate');
    if (!elHours || !elMinutes || !elSeconds || !elDelivery) return;

    function updateCountdown() {
        const now = new Date();
        const countdownHour = 13;
        let targetDate = new Date(now);
        targetDate.setHours(countdownHour, 0, 0, 0);
        if (now.getHours() >= countdownHour) {
            targetDate.setDate(targetDate.getDate() + 1);
        }

        const diff = targetDate - now;
        const hoursLeft = Math.floor(diff / 1000 / 60 / 60);
        const minutesLeft = Math.floor(diff / 1000 / 60) % 60;
        const secondsLeft = Math.floor(diff / 1000) % 60;
        const deliveryHours = 12; //Teslimat saatinin deadline'ı

        elHours.textContent = hoursLeft.toString().padStart(2, '0');
        elMinutes.textContent = minutesLeft.toString().padStart(2, '0');
        elSeconds.textContent = secondsLeft.toString().padStart(2, '0');

        let deliveryDays = 1;
        if (now.getDay() === 6) { // Eğer bugün Cumartesi ise
            deliveryDays = 3; // Teslim süresini 3 güne çıkar
        }

        let deliveryDate = new Date(now.getTime() + (deliveryDays * 24 * 60 * 60 * 1000));

        // Kargoya hafta sonu teslim yapılmıyorsa tarihi ayarla
        if (deliveryDate.getDay() === 6) { // Cumartesi
            deliveryDate.setDate(deliveryDate.getDate() + 2); // Pazartesiye ayarla
        } else if (deliveryDate.getDay() === 0) { // Pazar
            deliveryDate.setDate(deliveryDate.getDate() + 1); // Pazartesiye ayarla
        }

        let deliveryDateString;

      if ((hoursLeft > deliveryHours && now.getDay() == 6) || now.getDay()==7){
        deliveryDateString = "Pazartesi"
      } else if(now.getDay()== 0 || hoursLeft > deliveryHours){
        deliveryDateString = "Yarın"
      } else{
        deliveryDateString = "Bugün"
      }

        elDelivery.textContent = deliveryDateString;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000); // her saniye güncelle
});
